var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_c('h1',{class:_vm.$style.text},[_vm._t("default")],2),_c('div',{class:_vm.$style.line})])}
var staticRenderFns = []

export { render, staticRenderFns }